// GENERAL
import React from "react";

// COMPONENTS
import { BaseText, BaseContainer } from "../../../../../../components";

// TYPES
import { BundleFeeProps } from "../../types";

// UTILS
import { formatCurrency } from "../../../../../../utils";

const BundleFee: React.FC<BundleFeeProps> = ({
	bundleFee,
	leaseSuffix,
	currencySymbol,
	partNumberPrefix,
}) => {
	///// DATA TO VARS /////
	const { bundleItem } = bundleFee;
	const { _leasePrice, _unitPrice, item } = bundleItem;
	const { title, partNumber } = item;
	///// CONDITIONAL VARS/COMPS /////

	let priceToDisplay;

	if (_leasePrice) {
		priceToDisplay = `${currencySymbol}${formatCurrency(
			Number(_leasePrice)
		)}${leaseSuffix}`;
	} else {
		priceToDisplay = `${currencySymbol}${formatCurrency(
			Number(_unitPrice)
		)}`;
	}

	//// CLASS NAMES ////
	const containerClasses = `rounded-lg w-full border-transparent text-left pt-2.5`;
	const contentContainerClasses = `flex justify-between items-center w-full`;
	return (
		<BaseContainer
			key={bundleFee?.uuid}
			columnContainerClasses={containerClasses}
			columnShape="semi-rounded"
		>
			<div className={contentContainerClasses}>
				<div className="flex flex-col text-left">
					<BaseText
						text={title}
						size="sm:text-lg text-sm"
						color="text-navy-500"
						fontFamily="font-inter-semibold"
						tag="h3"
					/>
					<BaseText
						text={`${partNumberPrefix} ${partNumber}`}
						size="sm:text-base text-sm"
						color="text-primary-text"
						fontFamily="font-inter-regular"
						tag="p"
					/>
					<BaseText
						text={priceToDisplay}
						size="sm:text-base text-sm"
						color="text-navy-500"
						tag="p"
						fontFamily="font-inter-regular"
					/>
				</div>
			</div>
		</BaseContainer>
	);
};

export default BundleFee;
